// frontend/src/hooks/usePageTitle.js
import { useEffect } from "react";
import useChurchBrand from "./useChurchBrand";

/**
 * Define o título da aba do navegador.
 * Ex.: usePageTitle("Relatórios") => "Relatórios — <igreja da sessão>"
 * O site público indica o sufixo (o visitante não tem sessão).
 */
export default function usePageTitle(title, { suffix } = {}) {
  const { shortName } = useChurchBrand();
  const tail = suffix === undefined ? shortName : suffix;
  useEffect(() => {
    const parts = [title, tail].filter(Boolean);
    document.title = parts.length ? parts.join(" — ") : "Painel da igreja";
  }, [title, tail]);
}

